import { Control, FieldValues, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { IPublishDestination } from 'src/components/PublishModal/types';
import { ITimetableEntityGroup } from 'src/utils/timetables/groupSchedulesByEntity';

export interface IModalProps {
  closeModal?: () => void;
  isOpen: boolean;
  timetableId: string;
  timetableName: string;
}

export enum TimetablePublishSteps {
  Setup = 0,
  Venues = 1,
  Summary = 2,
}

export interface ITimetableSetupViewProps {
  control: Control<FieldValues>;
  register: UseFormRegister<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  timetableName: string;
  publicationData: IPublishDestination[];
}

export interface ITimetableSummaryViewProps {
  watch: UseFormWatch<FieldValues>;
  timetableName: string;
  publicationData: IPublishDestination[];
  entityGroups: ITimetableEntityGroup[];
}
